export function getPearson(x: number[], y: number[]) {
  /* This function calculates and returns the Pearson's Correlation Coefficient
    between the
    equal length lists x and y (where the lists contain numbers).
    */
  var arrayLength = x.length;

  var sumX = 0;
  var sumY = 0;
  var sumXSquared = 0;
  var sumYSquared = 0;
  var sumXY = 0;

  for (var i = 0; i < arrayLength; i++) {
    sumX += x[i];
    sumY += y[i];
    sumXSquared += x[i] * x[i];
    sumYSquared += y[i] * y[i];
    sumXY += x[i] * y[i];
  }

  var numerator = sumXY - (sumX * sumY) / arrayLength;
  var denominator = Math.sqrt(
    (sumXSquared - (sumX * sumX) / arrayLength) *
      (sumYSquared - (sumY * sumY) / arrayLength)
  );
  if (denominator < 1e-5) {
    return 0;
  } else {
    return numerator / denominator;
  }
}
